import { get } from "lodash";

import { ServiceParameters } from "./types";

export type JSONBooleanExpression =
    | ["and", ...JSONBooleanExpression[]]
    | ["or", ...JSONBooleanExpression[]]
    | [string, "=" | "!=", string | string[] | boolean];

export function evaluateExpression(
    params: ServiceParameters,
    path: string[],
    expression?: JSONBooleanExpression,
): boolean {
    if (!expression) {
        return true;
    }

    const [first, second, ..._] = expression;

    if (first === "and") {
        const otherExpressions = [...expression].slice(
            1,
        ) as JSONBooleanExpression[];
        return otherExpressions.every(e => evaluateExpression(params, path, e));
    } else if (first === "or") {
        const otherExpressions = [...expression].slice(
            1,
        ) as JSONBooleanExpression[];
        return otherExpressions.some(e => evaluateExpression(params, path, e));
    } else if (second === "=" || second === "!=") {
        const [conditionPath, condition, conditionValue] = expression;
        const peerPath = [...path];
        peerPath.pop();
        peerPath.push(conditionPath);
        const currentValue = get(params, peerPath);
        let result = false;
        if (Array.isArray(conditionValue)) {
            result = conditionValue.includes(currentValue);
        } else if (
            currentValue === conditionValue ||
            (conditionValue === "" &&
                (currentValue === null || currentValue === undefined))
        ) {
            result = true;
        }
        if (condition === "!=") {
            result = !result;
        }
        return result;
    }

    throw new Error("Invalid expression: " + JSON.stringify(expression));
}
